
const employeeEditAdapter = (employee) => {

  // console.log('employee', employee)

  const formatFloat = (value) => parseFloat(String(value).replace(/[^0-9.-]+/g, '') || 0).toFixed(2)
  const isMarried = (familystate) => ['C', 'U'].includes(familystate)

  return {
    ...employee,
    batchchildId: employee?.batchChild?.id,
    nationality: employee?.nationality?.value,
    country: employee?.country?.value,
    departament: employee?.departament?.value,
    municipality: employee?.municipality?.value,
    gender: employee?.gender?.value,
    familystate: employee?.familystate?.key,
    nameWife: isMarried(employee?.familystate?.key) ? employee?.nameWife : '',
    placeExpeditionDui: employee?.placeExpeditionDui?.value,
    countryExpeditionDui: employee?.countryExpeditionDui?.value,
    departamentExpeditionDui: employee?.departamentExpeditionDui?.value,
    cityExpeditionDui: employee?.cityExpeditionDui?.value,
    migratoryQuality: employee?.migratoryQuality?.value,
    domicileMunicipality: employee?.domicileMunicipality?.value,
    domicileCountry: employee?.domicileCountry?.value,
    domicileDepartament: employee?.domicileDepartament?.value,
    profession: employee?.profession?.value,
    salary: formatFloat(employee?.salary),
    countryEconomicalActivity: employee?.countryEconomicalActivity?.value,
    withdraw: formatFloat(employee?.withdraw),
    depositCash: formatFloat(employee?.depositCash),
    departamentEconomicalActivity: employee?.departamentEconomicalActivity?.value,
    municipalityEconomicalActivity: employee?.municipalityEconomicalActivity?.value,
    typerinformation1: employee?.typerinformation1?.value,
    typerinformation2: employee?.typerinformation2?.value,
    typerinformation3: employee?.typerinformation3?.value,
    typerinformation4: employee?.typerinformation4?.value,
    relationship: employee?.relationship?.value,
    relationship2: employee?.relationship2?.value,
    relationshi3: employee?.relationshi3?.value,
    relationship4: employee?.relationship4?.value,
  }
}

export default employeeEditAdapter
